import e from "clsx";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/components/CountrySelector/base/CountryOptionRow.tsx
function r({ country: r, name: i, checked: a, onSelect: o }) {
	return /* @__PURE__ */ n("label", {
		className: e("relative flex h-11 w-full cursor-pointer items-center justify-between gap-4 px-3 py-2", "hover:bg-neutral-100 has-checked:bg-neutral-100", "has-focus-visible:outline-2 has-focus-visible:-outline-offset-2 has-focus-visible:outline-focus", "forced-colors:has-checked:outline forced-colors:has-checked:-outline-offset-2"),
		children: [
			/* @__PURE__ */ t("input", {
				type: "radio",
				name: i,
				value: r.id,
				checked: a,
				onChange: () => o(r.id),
				className: "sr-only"
			}),
			/* @__PURE__ */ n("span", {
				className: "flex items-center gap-2",
				children: [/* @__PURE__ */ t("span", {
					"aria-hidden": "true",
					className: "flex size-6 shrink-0 items-center justify-center [&>svg]:w-full",
					children: r.flag
				}), /* @__PURE__ */ t("span", {
					className: "text-sm/5 font-medium text-black",
					children: r.label
				})]
			}),
			r.description ? /* @__PURE__ */ t("span", {
				className: "text-sm/5 text-neutral-700",
				children: r.description
			}) : null
		]
	});
}
//#endregion
export { r as CountryOptionRow };
